<template>
  <div class="card card-chart" id="nilaiTransaksiDivBar">
    <div class="card-header mt-2">
      <h4 class="card-title">Nilai Transaksi</h4>
    </div>
    <div class="card-body mb-5 mt-4 text-center">
      <!-- <div class="text-center">
        <i
          class="far fa-credit-card text-primary filterImg floatTrigger mb-4 float"
          aria-hidden="true"
          style="font-size: 500%; font-weight: 600"
        ></i>

        <p class="text-secondary">Start creating your first content</p>
        <a href="#" class="text-primary">Create a Product</a>
      </div> -->

      <i
        class="fas fa-coins text-primary filterImg"
        aria-hidden="true"
        style="font-size: 40px;"
      ></i>
      <div class="table-responsive mt-4">
        <table
          id="nilai_transaksi"
          class="table table-condensed text-center"
          width="100%"
        >
          <thead>
            <tr class="table-condensed">
              <th>Status</th>
              <th>Jumlah</th>
              <th>Nilai</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in nilaiTransaksiItems"
              :key="item.id"
              class="text-left"
            >
              <td style="width: 40%">
                <p class="mb-0 text-muted">
                  {{ item.name }}
                </p>
              </td>
              <td style="width: 25%">
                <h5 class="mb-0">{{ item.total }}</h5>
              </td>
              <td>
                <p class="mb-0 text-muted">{{ item.valueCurrencyFormat }}</p>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="text-left">
                <h5 class="mb-0" style="font-size: 12px">
                  Total :
                </h5>
              </td>
              <td class="text-left">
                <h5 class="mb-0" style="font-size: 12px">
                  {{ nilaiTransaksi.total }}
                </h5>
              </td>
              <td class="text-left">
                <h5 class="mb-0" style="font-size: 12px">
                  {{ nilaiTransaksi.valueCurrencyFormat }}
                </h5>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      fakeLooping: 10,
      nilaiTransaksi: {},
      nilaiTransaksiItems: {},
    };
  },
  created() {
    this.attrDashboard();
  },
  methods: {
    attrDashboard() {
      let dashboardUrl = "seller/dashboard";
      axios
        .get(dashboardUrl)
        .then((response) => {
          return response.data.data;
        })
        .then((data) => {
          // console.log(data.sectionStatistic.transactionValue.items)
          this.nilaiTransaksi = data.sectionStatistic.transactionValue;
          this.nilaiTransaksiItems =
            data.sectionStatistic.transactionValue.items;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.table{
    width: 100%;
}

@media (max-width: 1410px) {
    .table {
        width: 100%;
    }
}

@media (max-width: 517px) {
    .table {
        width: 100%;
    }
}
</style>